import { faEarthAmericas } from '@fortawesome/sharp-duotone-solid-svg-icons/faEarthAmericas'
import { faLock } from '@fortawesome/sharp-duotone-solid-svg-icons/faLock'
import { faUserGroup } from '@fortawesome/sharp-duotone-solid-svg-icons/faUserGroup'

export default [
  {
    "icon": faEarthAmericas,
    "message": "The largest selection of spaces in the world",
    "translationKey": "directives.search.reassuranceBanner.largestSelection"
  },
  {
    "icon": faLock,
    "message": "Flexible cancelations for your peace of mind",
    "translationKey": "directives.search.reassuranceBanner.hassleFree"
  },
  {
    "icon": faUserGroup,
    "message": "Join thousands of likeminded renters in the Storefront family",
    "translationKey": "directives.search.reassuranceBanner.joinThousands"
  }
]
